import { getConfigObject } from "../../utils/utils";
import {
  RolePrivilegeMapping,
  RolesAndPrivilegesControllerApi,
} from "../../services";
import { useMutation } from "@tanstack/react-query";

/**
 * @author Atish Bagate
 */
interface Params {
  rolePrivilegeMapping: RolePrivilegeMapping[];
  xTENANTID?: string;
}
export const useAddRolePrevileges = () =>
  useMutation({
    mutationFn: async (params: Params) =>
      new RolesAndPrivilegesControllerApi(
        getConfigObject()
      ).addRoleAndPrivilege(params?.rolePrivilegeMapping, params?.xTENANTID),
  });
